<h2 mat-dialog-title>Production Download</h2>
<mat-dialog-content>
    <div *ngIf="urls?.length">
        <div style="margin: 25px 0;">
            <span style="font-weight:600">{{productionJob.title}}</span> is now ready for download!
        </div>
    </div>
    <div style="min-width: 375px; padding-right: 24px; margin-bottom: 25px;">
        <div *ngIf="urls?.length > 1">
            <a *ngFor="let url of urls; index as i" href="{{url}}" class="download-row-link" >
                <div class="download-row">
                    <div class="fa-duotone fa-download" style="padding: 0 14px;"></div>
                    <div>Download part {{i+1}} </div>
                </div>
            </a>
        </div>
        <div *ngIf="urls?.length === 1">
            <a href="{{urls[0]}}" class="download-row-link" >
                <div class="download-row">
                    <div class="fa-duotone fa-download" style="padding: 0 14px;"></div>
                    <div>Download production now</div>
                </div>
            </a>
        </div>
    </div>
    <div *ngIf="!urls?.length">
        <div style="margin-top: 25px;">
            <span style="font-weight:600">{{productionJob.title}}</span> is being prepared and will be available for
            download shortly and could take several minutes depending on the size of the production.
        </div>
        <div style="display: flex; justify-content: center">
            <mat-spinner [diameter]="35" color="primary" style="margin: 25px;"></mat-spinner>
        </div>
    </div>

</mat-dialog-content>
<mat-dialog-actions style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
    <button id="cancel-download-production-dialog-button" mat-raised-button color="secondary" mat-dialog-close>Close
    </button>
</mat-dialog-actions>
